<template>
  <v-app>
    <div class="row">
      <div class="col-12">
       <div class="card">
         <div class="card-header">
           <div class="card-title pt-3 px-3 d-flex justify-content-between">
             <div class="breadcrumb-left">
               <h4>Online classrooms</h4>
               <div class="breadcrumb-sub-header">
                 <router-link to="/dashboard">Dashboard</router-link>
                 \   Online classrooms
               </div>
             </div>
             <div class="breadcrumb-right">
               <div class="card-toolbar">
                 <v-btn @click="addRooms()" class="mt-4 btn btn-primary" style="color: #fff">
                   <v-icon small elevation="2" outlined>fas fa-plus</v-icon>&nbsp;
                   Add online classroom
                 </v-btn>
               </div>
             </div>
           </div>
         </div>
      <div class="card-body ">
        <div class="search-wrapper border-outline mb-5 px-3 py-5 d-sm-flex justify-content-start">
          <div class="row">
            <div class="col-md-2 col-12">
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dates"
                      label="Dates"
                      prepend-icon="mdi-calendar"
                      readonly v-on:keyup.enter="searchResult()"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dates"
                    range
                ></v-date-picker>
              </v-menu>

            </div>
            <div class="col-md-2 col-12">
              <v-select label="Course"
                        :loading="loading"
                        outlined dense v-on:keyup.enter="searchResult()"
                        :items="assigned_courses"
                        item-text="display_title"
                        item-value="id"
                        v-model="search.linked_subject"></v-select>
            </div>
            <div class="col-md-2 col-12">
              <v-select label="Class"
                        :loading="loading"
                        outlined dense v-on:keyup.enter="searchResult()"
                        :items="academic_classes"
                        item-text="display_title"
                        item-value="id"
                        v-model="search.linked_class"></v-select>
            </div>
            <div class="col-md-2 col-12">
              <v-select label="Status" outlined dense :items="active_statuses" item-text="title"    v-on:keyup.enter="searchResult()"
                        item-value="value"
                        v-model="search.active"></v-select>
            </div>
<!--            <div class="col-md-2 col-12">
              <v-btn depressed class="btn btn-primary text-white" @click="searchResult">Filter</v-btn>
              <v-btn depressed class="btn btn-standard ml-2" @click="resetFilter">Reset</v-btn>
            </div>-->
            <v-col cols="12" md="12" class="text-right">
              <v-btn
                  @click="searchResult()"
                  class="btn btn-primary btn-search "
                  :loading="isLoading"
              >
                <v-icon small elevation="2" outlined>fas fa-search</v-icon>&nbsp;
                Search
              </v-btn>
            </v-col>
          </div>
        </div>
<!--        <div class="table-responsive">
          <v-skeleton-loader
              type="table-thead"
              v-if="isLoading"
          >
          </v-skeleton-loader>

          <v-skeleton-loader
              v-if="isLoading"
              type="table-row-divider@25"
          >
          </v-skeleton-loader>
          <table class="table">

          </table>
        </div>-->

      </div>
    </div>
      </div>
    </div>
    <div v-if="isLoading" class="mt-3">
      <div class="row">
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-md-3 col-6">
          <v-skeleton-loader
              type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader
              type="image"
          ></v-skeleton-loader>
        </div>
      </div>

    </div>

    <div class="row mt-2" v-else>
      <div class="col-12">
        <div class="row" v-if="days_rooms.length>0">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <template>
                  <v-card>
                    <v-tabs vertical>
                      <v-tab>
                        <v-icon left>
                          mdi-access-point-network
                        </v-icon>
                        Online Classes
                      </v-tab>
                      <v-tab>
                        <v-icon left>
                          mdi-record-circle
                        </v-icon>
                        Recorded Classes
                      </v-tab>

                      <v-tab-item class="p-4 bg-white">
                        <div class="" v-if="days_rooms && days_rooms.length>0">
                          <online-class-room-list :rooms="days_rooms"></online-class-room-list>
                          <div class="col-12" v-if="total>perPage">
                            <b-pagination
                                @input="getRooms"
                                v-model="page"
                                :total-rows="total"
                                :per-page="perPage"
                                first-number
                                last-number
                            ></b-pagination>
                            <!--  -->
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-12 text-center">
                            <h6>No class room found</h6>
                          </div>
                        </div>
                      </v-tab-item>
                      <v-tab-item class="p-4 bg-white">
                        <div class="" v-if="recorded_rooms && recorded_rooms.length>0">
                          <recorded-online-class-room-list :rooms="recorded_rooms"></recorded-online-class-room-list>
                          <div class="col-12" v-if="recorded_total>recorded_perPage">
                            <b-pagination
                                @input="getRecordedRooms"
                                v-model="recorded_page"
                                :total-rows="recorded_total"
                                :per-page="recorded_perPage"
                                first-number
                                last-number
                            ></b-pagination>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-12 text-center">
                            <h6>No class room found</h6>
                          </div>
                        </div>
                      </v-tab-item>
                    </v-tabs>
                  </v-card>
                </template>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <!--      <div class="col-6">-->
    <!--        <div class="card mb-3">-->
    <!--          <div class="card-body">-->
    <!--            <v-sheet height="64">-->
    <!--              <v-toolbar-->
    <!--                  flat-->
    <!--              >-->
    <!--                <v-btn-->
    <!--                    outlined-->
    <!--                    class="mr-4"-->
    <!--                    color="grey darken-2"-->
    <!--                    @click="setToday"-->
    <!--                >-->
    <!--                  Today-->
    <!--                </v-btn>-->
    <!--                <v-btn-->
    <!--                    fab-->
    <!--                    text-->
    <!--                    small-->
    <!--                    color="grey darken-2"-->
    <!--                    @click="prev"-->
    <!--                >-->
    <!--                  <v-icon small>-->
    <!--                    mdi-chevron-left-->
    <!--                  </v-icon>-->
    <!--                </v-btn>-->
    <!--                <v-btn-->
    <!--                    fab-->
    <!--                    text-->
    <!--                    small-->
    <!--                    color="grey darken-2"-->
    <!--                    @click="next"-->
    <!--                >-->
    <!--                  <v-icon small>-->
    <!--                    mdi-chevron-right-->
    <!--                  </v-icon>-->
    <!--                </v-btn>-->
    <!--                <v-toolbar-title v-if="$refs.calendar">-->
    <!--                  {{ $refs.calendar.title }}-->
    <!--                </v-toolbar-title>-->
    <!--                <v-spacer></v-spacer>-->
    <!--                <v-menu-->
    <!--                    bottom-->
    <!--                    right-->
    <!--                >-->
    <!--                  <template v-slot:activator="{ on, attrs }">-->
    <!--                    <v-btn-->
    <!--                        outlined-->
    <!--                        color="grey darken-2"-->
    <!--                        v-bind="attrs"-->
    <!--                        v-on="on"-->
    <!--                    >-->
    <!--                      <span>{{ typeToLabel[ctype] }}</span>-->
    <!--                      <v-icon right>-->
    <!--                        mdi-menu-down-->
    <!--                      </v-icon>-->
    <!--                    </v-btn>-->
    <!--                  </template>-->
    <!--                  <v-list>-->
    <!--                    <v-list-item @click="ctype = 'day'">-->
    <!--                      <v-list-item-title>Day</v-list-item-title>-->
    <!--                    </v-list-item>-->
    <!--                    <v-list-item @click="ctype = 'week'">-->
    <!--                      <v-list-item-title>Week</v-list-item-title>-->
    <!--                    </v-list-item>-->
    <!--                    <v-list-item @click="ctype = 'month'">-->
    <!--                      <v-list-item-title>Month</v-list-item-title>-->
    <!--                    </v-list-item>-->
    <!--                    <v-list-item @click="ctype = '4day'">-->
    <!--                      <v-list-item-title>4 days</v-list-item-title>-->
    <!--                    </v-list-item>-->
    <!--                  </v-list>-->
    <!--                </v-menu>-->
    <!--              </v-toolbar>-->
    <!--            </v-sheet>-->
    <!--            <v-sheet height="400">-->
    <!--              <v-calendar-->
    <!--                  ref="calendar"-->
    <!--                  v-model="focus"-->
    <!--                  :type="ctype"-->
    <!--                  :event-overlap-mode="mode"-->
    <!--                  :events="items"-->
    <!--                  event-text-color="white"-->
    <!--                  category-show-all-->
    <!--                  :event-more="more"-->
    <!--                  @click:event="showEvent"-->
    <!--                  @click:date="viewDay"-->
    <!--              ></v-calendar>-->
    <!--              <v-menu-->
    <!--                  v-model="selectedOpen"-->
    <!--                  :close-on-content-click="false"-->
    <!--                  :activator="selectedElement"-->
    <!--                  offset-x-->
    <!--              >-->
    <!--                <v-card-->
    <!--                    color="grey lighten-4"-->
    <!--                    min-width="350px"-->
    <!--                    flat-->
    <!--                >-->
    <!--                  <v-toolbar-->
    <!--                      :color="selectedEvent.color"-->
    <!--                      dark-->
    <!--                  >-->

    <!--                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>-->
    <!--                    <v-spacer></v-spacer>-->

    <!--                  </v-toolbar>-->
    <!--                  <v-card-text>-->
    <!--                    <h5>{{ selectedEvent.type }}</h5>-->
    <!--                    <span v-html="selectedEvent.content"></span>-->
    <!--                  </v-card-text>-->
    <!--                  <v-card-actions>-->
    <!--                    <v-btn-->
    <!--                        text-->
    <!--                        color="secondary"-->
    <!--                        @click="selectedOpen = false"-->
    <!--                    >-->
    <!--                      Cancel-->
    <!--                    </v-btn>-->
    <!--                  </v-card-actions>-->
    <!--                </v-card>-->
    <!--              </v-menu>-->
    <!--            </v-sheet>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->



    <div class="row">
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ text }}
        <v-btn color="blue" text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <div class="row mt-2" v-if="!isLoading && rooms.length<1">
      <div class="col-md-12 text-center">
        <v-card class="p-20">
          <img src="@/assets/media/images/no-data-found.png">
          <h5 class="mt-10">No online classroom available. Classroom will appear once added.</h5>
        </v-card>
      </div>
    </div>
  </v-app>
</template>
<script>

import {SiteSettingMixin} from "@/mixins/SiteSettingMixin";
import GeneralMixin from "@/mixins/GeneralMixin";
import draggable from 'vuedraggable'
import OnlineClassRoomsService from "@/core/services/online-class-rooms/OnlineClassRoomsService";
import OnlineClassRoomList from "@/view/component/online-class-room/OnlineClassRoomList";
import RecordedOnlineClassRoomList from "@/view/component/online-class-room/RecordedOnlineClassRoomList";


const onlineCLassRoom = new OnlineClassRoomsService();
export default {
  name: "rooms",
  mixins: [SiteSettingMixin, GeneralMixin],
  display: "Table",
  order: 8,
  components: {
     OnlineClassRoomList, RecordedOnlineClassRoomList
  },
  data() {
    return {
      isLoading: false,
      menu: false,
      active_statuses: [
        {title: 'Active', value: "active"},
        {title: 'In Active', value: "in_active"}
      ],
      sort_by: [
        {title: 'A-Z', value: "asc"},
        {title: 'Z-A', value: "desc"}
      ],
      rooms: [],
      days_rooms: [],
      dates: [],
      snackbar: false,
      text: "My timeout is set to 2000.",
      timeout: 2000,
      page: null,
      perPage: null,
      total: null,
      search: {
        active: "active",
        is_parent: null,
        search_type: null,
        dates:[],
        request_from: "teacher"
      },

      dragging: false,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      more: false,
      mode: 'column',
      focus: '',
      ctype: 'month',
      types: ['month', 'week', 'day', '4day'],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      recorded_rooms: [],
      recorded_page: null,
      recorded_total: null,
      recorded_perPage: null,
    };
  },

  mounted() {
    if(this.checkTeacherMenuAccess('online_classroom')==false ){
      this.$router.push({name: '404'})
    }
    this.getAssignedTeacherCourses();
    this.getAcademicClasses();
    if (this.setDefaultDates()) {
      this.searchResult();
    }
  },

  computed: {
    items() {
      const items = [];
      this.rooms.forEach((item) => {
        let startDate = new Date(item.calendar_date).toISOString().substring(0, 10);
        items.push({
          name: item.title,
          start: startDate,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: false,
        })
      })
      return items;
    },
  },
  methods: {
    endDurationDate(room) {
      return this.$moment(room.start_from).add(room.duration, 'minutes').format('hh:mm A')
    },
    searchResult() {
      this.search.dates = []
      if (this.dates && this.dates.length > 0) {
        this.search.dates = this.dates
      }
      this.getOnlineClassRooms()
      this.getRecordedRooms()
    },  setDefaultDates() {
      this.dates = [];
      let startDate = this.$moment(new Date).format('YYYY-MM-DD');
      let endDate = this.$moment(new Date).add(7, 'days').format('YYYY-MM-DD');
      this.dates.push(startDate)
      this.dates.push(endDate)
      return true
    },
    getOnlineClassRooms() {
      this.isLoading = true;
      this.search.search_type = null
      onlineCLassRoom
          .paginateOnlineClassRoom(this.search, this.page)
          .then(response => {
            this.days_rooms = response.data.data;
            this.page = response.data.meta.current_page;
            this.total = response.data.meta.total;
            this.perPage = response.data.meta.per_page;
            this.loading = false;
          })
          .catch(error => {
          }).finally(() => {
        this.isLoading = false;
      });
    },
    getRecordedRooms() {
      this.isLoading = true;
      this.search.search_type = "recorded"
      onlineCLassRoom
          .paginateOnlineClassRoom(this.search, this.recorded_page)
          .then(response => {
            this.recorded_rooms = response.data.data
            this.recorded_page = response.data.meta.current_page;
            this.recorded_total = response.data.meta.total;
            this.recorded_perPage = response.data.meta.per_page;
            this.loading = false;
          })
          .catch(error => {
          }).finally(() => {
        this.isLoading = false;
      });
    },
    getAllClasses() {
      this.isLoading = true;
      this.rooms = []
      onlineCLassRoom
          .getAllClasses(this.search, this.page)
          .then(response => {
            this.rooms = response.data.data;
            this.loading = false;
          })
          .catch(error => {
          }).finally(() => {
        this.isLoading = false;
      });
    },
    inviteLinkCopy(link) {
      return link
    },
    onCopy: function (e) {
      this.text = "Link Copied";
      this.snackbar = true;
    },
    onError: function (e) {
      this.text = "Failed to copy ";
      this.snackbar = true;
    },
    addRooms() {
      this.$router.push({name: 'online-class-rooms-create'})
    },
    editRooms(id) {
      this.$router.push({name: 'online-class-rooms-update', params: {room_id: id}})
    },
    manageCategory() {
      this.$refs['manageCategory'].showModal();
    },

    deleteRooms(id) {
      this.$confirm({
        message: `Are you sure you want to delete this classroom permanently?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            onlineCLassRoom
                .delete(id)
                .then(response => {
                  this.$snotify.success("Online Classroom Deleted")
                  this.getOnlineClassRooms();
                  this.getAllClasses();
                })
                .catch(error => {
                });
          }
        }
      });
    },
    sort() {
      onlineCLassRoom.sort(this.rooms).then((res) => {
        this.$snotify.success("Classroom Sorted");
        this.getOnlineClassRooms()
      }).catch(err => {
        this.$snotify.success("Could not sort. Please contact admin");
      })
    },
    detail(id) {
      this.$router.push({name: "room-photo", params: {id: id}});
    },
    resetFilter() {
      this.search = {
        active: "active",
        request_from: "teacher"
      }
      this.searchResult();
    },
    showEvent({nativeEvent, event}) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    viewDay({date}) {
      this.search.date = date;
      this.getOnlineClassRooms();
    },
    setToday() {
      this.focus = ''
    },
  }
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
</style>
